'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attributeLeadIfReferred = exports.provision = exports.setSelectedPortal = exports.partnerIdFromQueryParam = exports.didShowPartnerPrivacy = undefined;
exports.getPartnerPrivacyLink = getPartnerPrivacyLink;

var _reduxActions = require('redux-actions');

var _PartnerActionTypes = require('../actionTypes/PartnerActionTypes');

var _leadAttributionApi = require('../api/leadAttributionApi');

var _PartnerDAO = require('../data/PartnerDAO');

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _Partner = require('../selectors/Partner');

var _UserInfo = require('../selectors/UserInfo');

var _AnalyticsActions = require('./AnalyticsActions');

var _AuthenticationActions = require('./AuthenticationActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG = _Logger2.default.getLogger('PartnerActions');

var requestPartnerPrivacyLink = (0, _reduxActions.createAction)(_PartnerActionTypes.REQUEST_PARTNER_PRIVACY_LINK);
var succeedGetPartnerPrivacyLink = (0, _reduxActions.createAction)(_PartnerActionTypes.SUCCEED_GET_PARTNER_PRIVACY_LINK);
var failedGetPartnerPrivacyLink = (0, _reduxActions.createAction)(_PartnerActionTypes.FAILED_GET_PARTNER_PRIVACY_LINK);
var didShowPartnerPrivacy = exports.didShowPartnerPrivacy = (0, _reduxActions.createAction)(_PartnerActionTypes.DID_SHOW_PARTNER_PRIVACY);
var portalSelected = (0, _reduxActions.createAction)(_PartnerActionTypes.PORTAL_SELECTED);
var partnerProvisioningCompleted = (0, _reduxActions.createAction)(_PartnerActionTypes.PARTNER_PROVISIONING_COMPLETED);
var partnerProvisioningFailed = (0, _reduxActions.createAction)(_PartnerActionTypes.PARTNER_PROVISIONING_FAILED);
var partnerIdFromQueryParam = exports.partnerIdFromQueryParam = (0, _reduxActions.createAction)(_PartnerActionTypes.PARTNER_ID_FROM_QUERY_PARAM);

function logFailedFetchPartnerPrivacyLik(error) {
  LOG.error('Failed to fetch partner privacy link', {
    extra: { error: error }
  });
}

function getPartnerPrivacyLink(partnerId) {
  return function (dispatch) {
    dispatch(requestPartnerPrivacyLink(partnerId));
    (0, _AnalyticsActions.trackEvent)('partner', { action: 'partner info requested', partnerId: partnerId });
    try {
      (0, _PartnerDAO.fetchPartnerPrivacyLink)(partnerId).then(function (privacyLink) {
        dispatch(succeedGetPartnerPrivacyLink(privacyLink));
        (0, _AnalyticsActions.trackEvent)('partner', { action: 'partner info received', partnerId: partnerId });
      }, function (e) {
        dispatch(failedGetPartnerPrivacyLink(e));
        logFailedFetchPartnerPrivacyLik(e);
        (0, _AnalyticsActions.trackEvent)('partner', {
          action: 'partner info request failed',
          partnerId: partnerId
        });
      });
    } catch (e) {
      dispatch(failedGetPartnerPrivacyLink(e));
      (0, _AnalyticsActions.trackEvent)('partner', {
        action: 'partner info request generic failure',
        partnerId: partnerId
      });
      logFailedFetchPartnerPrivacyLik(e);
    }
  };
}

var setSelectedPortal = exports.setSelectedPortal = function setSelectedPortal(portalId) {
  return function (dispatch) {
    (0, _AuthenticationActions.changePrimaryHub)(portalId).then(function () {
      dispatch(portalSelected(portalId));
    });
  };
};

var provision = exports.provision = function provision(partnerType, domain) {
  return function (dispatch) {
    (0, _PartnerDAO.provisionPartner)(partnerType, domain).then(function () {
      dispatch(partnerProvisioningCompleted());
    }).catch(function (e) {
      dispatch(partnerProvisioningFailed(e.responseJSON) || {});
    });
  };
};
var attributeLeadIfReferred = exports.attributeLeadIfReferred = function attributeLeadIfReferred() {
  return function (dispatch, getState) {
    var state = getState();
    var partnerId = (0, _Partner.getPartnerId)(state) || _QueryParamsContainer2.default.get('partnerId');
    var email = (0, _UserInfo.getEmail)(state) || _QueryParamsContainer2.default.get('email');
    if (partnerId && email) {
      var firstName = (0, _UserInfo.getFirstName)(state) || _QueryParamsContainer2.default.get('firstName');
      var lastName = (0, _UserInfo.getLastName)(state) || _QueryParamsContainer2.default.get('lastName');
      var domain = (0, _UserInfo.getDomain)(state) || _QueryParamsContainer2.default.get('domain');
      var company = (0, _UserInfo.getCompanyName)(state) || _QueryParamsContainer2.default.get('companyName');
      //this is needed, if I didn't show the privacy policy to the user, I can't give the info to the partner
      var shownPartnerPrivacy = (0, _Partner.getDidShowPartnerPrivacy)(state) || _QueryParamsContainer2.default.get('didShowPartnerPrivacy');
      if (!shownPartnerPrivacy) {
        LOG.warn('Calling lead attribution to partner with privacy policy set to false in the state', {
          extra: {
            partnerId: partnerId
          }
        });
      }
      (0, _leadAttributionApi.attributeLead)({
        hubId: partnerId,
        email: email,
        firstName: firstName,
        lastName: lastName,
        domain: domain,
        company: company,
        didShowPartnerPrivacy: shownPartnerPrivacy
      }).then(function () {
        (0, _AnalyticsActions.trackEventBeforeUnload)('partner', {
          action: 'attributed lead to partner',
          partnerId: partnerId
        });
        LOG.info('Attributed lead to partner', {
          extra: { partnerId: partnerId }
        });
      }).catch(function (resp) {
        var responseJSON = resp.responseJSON;

        (0, _AnalyticsActions.trackEventBeforeUnload)('partner', {
          action: 'failed attribution lead to partner - ' + responseJSON.type,
          partnerId: partnerId
        });
        LOG.error('Error attributing lead to partner', {
          extra: { partnerId: partnerId, resp: resp }
        });
      });
    }
  };
};